import { useCallback } from "react";
import { Message } from "@/frontend/components/common";
import type { ApiResponse } from "@/shared/dto/common";

interface UseDeleteOptions {
  deleteFn: (id: string) => Promise<ApiResponse<void>>;
  loadData: () => void;
  successMessage?: string;
  errorMessage?: string;
  showConfirm?: boolean;
  confirmTitle?: string;
  confirmDescription?: string;
}

export function useDelete({
  deleteFn,
  loadData,
  successMessage = "Elemento eliminado exitosamente",
  errorMessage = "Error al eliminar elemento",
  showConfirm = false,
  confirmTitle = "¿Estás seguro?",
  confirmDescription = "Esta acción no se puede deshacer",
}: UseDeleteOptions) {
  const handleDelete = useCallback(
    async (id: string) => {
      try {
        const response = await deleteFn(id);
        if (response.success) {
          Message.success({ content: successMessage });
          loadData();
        } else {
          Message.error({ content: response.error || errorMessage });
        }
      } catch (error) {
        Message.error({
          content: error instanceof Error ? error.message : errorMessage,
        });
      }
    },
    [deleteFn, loadData, successMessage, errorMessage]
  );

  return { 
    handleDelete,
    showConfirm,
    confirmTitle,
    confirmDescription,
  };
}
